import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import {
  getPaksham, getVaasaram, getAyane, getRuthu, getMaseTamil,
  getNakshatraYukthayaam, getThithyam, getYogam, getYogam2,
  getchandrashtamam, getPoruththam, getRahuKala, getSunrise,
  getKuliga, getYamaKanda, getSoola, getGoodTime,
  PANCHANGAM_API
} from '@/panchangam/services/panchangam-utils';

const T = { bg:'#f0f5e8', cream:'#fffef0', greenDk:'#1b5e20', maroon:'#6d1b1b', orange:'#e65100', border:'#c8e6c9', header:'linear-gradient(135deg,#090b72,#1a237e)' };

const CalendarPage = () => {
  const [pd, setPd] = useState(null);
  const [loading, setLoading] = useState(true);
  const [today, setToday] = useState(dayjs().format('YYYY-MM-DD'));
  const [computed, setComputed] = useState({});

  // Star Finder State
  const [starYear, setStarYear] = useState('39');
  const [starMonth, setStarMonth] = useState('1');
  const [starStar, setStarStar] = useState('1');
  const [starResult, setStarResult] = useState(null);
  const [starResult2, setStarResult2] = useState(null);
  const [starLoading, setStarLoading] = useState(false);

  const fetchPanchangam = useCallback(async (dateStr) => {
    setLoading(true);
    try {
      const res = await axios.get(PANCHANGAM_API, { params: { date: dateStr, time: '12pm' } });
      const data = res.data[0];
      if (data) {
        setPd(data);
        computeDerived(data);
      } else {
        setPd(null);
      }
    } catch (err) {
      // Fallback to local JSON
      try {
        const localRes = await axios.get('/data/panchangam_data-2025-to-2028.json');
        const d = new Date(dateStr);
        const formattedDate = `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
        const found = localRes.data.find(row => row.EnglishDate === formattedDate);
        if (found) {
          setPd(found);
          computeDerived(found);
        } else {
          setPd(null);
        }
      } catch (e2) {
        setPd(null);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  function computeDerived(data) {
    const paksham = getPaksham(data.PakshamNameInTamil, data.Paksham);
    const vasaram = getVaasaram(data.EnglishDay);
    const ayanam = getAyane(data.TamilMonthNumber);
    const ruthu = getRuthu(data.TamilMonthNumber);
    const masam = getMaseTamil(data.TamilMonthNumber);
    const nakshatram = getNakshatraYukthayaam(data.NakshatraNumber);
    const nakshatram2 = getNakshatraYukthayaam(data.Nakshatra2Number);
    const thithiyam = getThithyam(data.ThithiNumber);
    const thithyam2 = getThithyam(data.Thithi2Number);
    const yogam = getYogam(data.CalcDayYogamsShortInTamil);
    const yogam2 = getYogam2(data.CalcDayYogamsShortInTamil);
    const chandrasht1 = getchandrashtamam(data.NakshatraNumber);
    const chandrasht2 = getchandrashtamam(data.Nakshatra2Number);
    const porutham = getPoruththam(data.NakshatraNumber);
    const rahuKaalam = getRahuKala(data.EnglishDay);
    const suryaUdhayam = getSunrise(data.SuryaUdhayam);
    const kuligaiKaalam = getKuliga(data.EnglishDay);
    const yamakandam = getYamaKanda(data.EnglishDay);
    const soolam = getSoola(data.EnglishDay);
    const nallaNeram = getGoodTime(data.EnglishDay);

    let shradham = data.ShraadhdhaPakshamNameInTamil === 'சு' ? 'சுக்ல' : 'க்ருஷ்ண';

    setComputed({
      paksham, vasaram, ayanam, ruthu, masam, nakshatram, nakshatram2,
      thithiyam, thithyam2, yogam, yogam2, chandrasht1, chandrasht2,
      porutham, rahuKaalam, suryaUdhayam, kuligaiKaalam, yamakandam,
      soolam, nallaNeram, shradham
    });
  }

  useEffect(() => { fetchPanchangam(today); }, [today, fetchPanchangam]);

  const formatNumber = (val) => val != null ? Number(val).toFixed(2) : '';
  const formatEngDate = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    return `${String(d.getDate()).padStart(2,'0')} - ${String(d.getMonth()+1).padStart(2,'0')} - ${d.getFullYear()}`;
  };

  const handleStarSearch = async (e) => {
    e.preventDefault();
    setStarLoading(true);
    setStarResult(null);
    setStarResult2(null);
    try {
      // Trying API first as old app did
      const res = await axios.get(`https://brahminsnet.com:8082/v1/getPanchangamDetailsBasedOnInputs?tamilYearNumber=${starYear}&tamilMonthNumber=${starMonth}&starNumber=${starStar}`);
      const data = res.data;
      
      if (data && data.length > 0) {
        setStarResult(data[0]);
        if (data.length > 1) {
          setStarResult2(data[1]);
        }
      } else {
        // Old app fallback: star - 1 (allowed dates logic)
        const res2 = await axios.get(`https://www.brahminsnet.com:8082/v1/getAllowedDates?tamilYearNumber=${starYear}&tamilMonthNumber=${starMonth}&starNumber=${starStar-1}&isStage=true`);
        if (res2.data && res2.data.length > 0) {
          setStarResult(res2.data[0]);
          if (res2.data.length > 1) setStarResult2(res2.data[1]);
        }
      }
    } catch(err) {
      // Offline local search if API fails
      try {
         const localRes = await axios.get('/data/panchangam_data-2025-to-2028.json');
         const found = localRes.data.filter(row => 
           String(row.TamilYearNumber) === starYear && 
           String(row.TamilMonthNumber) === starMonth && 
           String(row.NakshatraNumber) === starStar
         );
         if (found.length > 0) setStarResult(found[0]);
         if (found.length > 1) setStarResult2(found[1]);
      } catch(e) {}
    } finally {
      setStarLoading(false);
    }
  };

  const c = computed;

  return (
    <div style={{background:T.bg,minHeight:'100vh',padding:'10px'}}>
      
      {/* Date Picker */}
      <div style={{ background:T.greenDk, padding:'10px', borderRadius:'10px', textAlign:'center', color:'#fff', marginBottom:'15px' }}>
        <div style={{ fontSize:'0.9rem', marginBottom:'8px' }}>Select Date for Panchangam:</div>
        <input type="date" value={today} onChange={(e) => setToday(e.target.value)}
            style={{ padding:'8px', fontSize:'16px', borderRadius:'8px', border:'none', textAlign:'center', width:'80%', maxWidth:'200px' }} />
      </div>

      {loading ? (
         <div style={{textAlign:'center', padding:'40px', fontWeight:'bold', color:T.greenDk}}>Please wait ....</div>
      ) : !pd ? (
         <div style={{textAlign:'center', padding:'40px', color:T.maroon}}>இந்த நாளுக்கு தரவு கிடைக்கவில்லை</div>
      ) : (
        <>
          {/* Header Details */}
          <div style={{ backgroundColor:'#090b72', color:'white', textAlign:'center', padding:'10px', borderRadius:'10px', marginBottom:'15px' }}>
            <div style={{ fontSize:'1.1rem', fontWeight:700 }}>
              {pd.YearNameInTamil}-{pd.AyanamNameInTamil}
            </div>
            <div style={{ color:'rgb(152, 248, 243)', fontSize:'0.9rem', margin:'4px 0' }}>
              {pd.RuthuNameInTamil}-ருது-{pd.TamilMonth}-{pd.TamilDate}
            </div>
            <div style={{ color:'yellow', fontSize:'1.0rem' }}>
              {formatEngDate(pd.EnglishDate)} - {pd.DayNameInTamil}
            </div>
          </div>

          {/* Core Daily Data */}
          <div style={{ backgroundColor:'#fff', borderRadius:'8px', padding:'5px', border:'1px solid '+T.border }}>
            <Row label="பக்ஷ-திதி" value={<>{c.paksham}-{pd.ThithiNameInTamil} ({formatNumber(pd.ThithiDuration)})&nbsp;IST <span style={{color:T.orange}}>வரை</span></>} />
            <Row label="நக்ஷத்ரம்" value={<>{pd.NakshatraNameInTamil} ({formatNumber(pd.NakshatraDuration)})&nbsp;IST <span style={{color:T.orange}}>வரை</span></>} />
            <Row label="யோகம்" value={<>{pd.YogaNameInTamil} ({formatNumber(pd.YogaDuration)})IST &nbsp;<span style={{color:T.orange}}>வரை</span></>} />
            <Row label="அ-சி யோக" value={<>{c.yogam}-{formatNumber(pd.NakshatraDuration)}&nbsp;<span style={{color:T.orange}}>&nbsp;&gt;&gt;&nbsp;</span>{c.yogam2}</>} />
            <Row label="கரண-யோ" value={<>{pd.KaranamNameInTamil} ({formatNumber(pd.KaranaDuration)}) &nbsp;<span style={{color:T.orange,fontSize:'12px'}}>- யோகி: -</span>{pd.Yogini}</>} />
            <Row label="நேத்-ஜீவன்" value={<><span style={{color:T.orange}}>நேத்ரம்:</span> {pd.Nethram}&nbsp;&nbsp;&nbsp;<span style={{color:T.orange}}>ஜீவன்:</span> {pd.Jeevan}</>} />
            <Row label="சூர்(சென்)" value={<><span style={{color:T.orange}}>உதய</span> {formatNumber(pd.SuryaUdhayam)} &nbsp;<span style={{color:T.orange}}>அஸ்த</span> {formatNumber(pd.AgasDuration)}</>} />
            <Row label="ராகுகால" value={<>{c.rahuKaalam} &nbsp;<span style={{color:T.orange,fontSize:'0.85rem'}}>{c.suryaUdhayam} Mins SunRise</span></>} />
            <Row label="எமகண்டம்" value={<>{c.yamakandam} &nbsp;<span style={{color:T.orange,fontSize:'0.85rem'}}>{c.suryaUdhayam} Mins SunRise</span></>} />
            <Row label="குளிகை" value={<>{c.kuligaiKaalam}&nbsp;<span style={{color:T.orange,fontSize:'0.85rem'}}>{c.suryaUdhayam} Mins SunRise</span></>} />
            <Row label="சூலம்:" value={c.soolam} smallFont />
            <Row label="சந்த்ராஷ்ட" value={<>{c.chandrasht1} {formatNumber(pd.NakshatraDuration)}&nbsp;<span style={{color:T.orange}}>&gt;&gt;</span>&nbsp;{c.chandrasht2}</>} />
            <Row label="நல்லநேரம்" value={c.nallaNeram} smallFont />
            <Row label="ச்ராத்-திதி" value={<>{pd.ShraadhdhaPakshamNameInTamil}-{pd.ShraadhdhaThithiNameInTamil}</>} />
            <Row label="பொருத்தம்" value={<>{c.porutham} -<span style={{fontSize:'0.65rem'}}>செட்களுக்குப் பொருந்தும்</span></>} smallLabel />
          </div>

          <div style={{ color:'red', backgroundColor:'yellow', fontSize:'0.8rem', fontWeight:600, textAlign:'center', padding:'6px', margin:'10px 0' }}>
            All Times 24hr IST || 24=Midnight, 25=1am, ... 29=5am
          </div>

          <div style={{ textAlign:'center', backgroundColor:'#04330c', color:'white', padding:'8px', fontWeight:'bold', fontSize:'0.9rem', marginTop:'15px' }}>
            {formatEngDate(pd.EnglishDate)} - விசேஷங்கள்
          </div>
          <div style={{ padding:'10px', fontSize:'0.9rem', backgroundColor:T.cream, color:T.maroon, minHeight:'30px' }}>
            {pd.DaySpecialityInTamil || ''}
          </div>

          {/* Graha Nilai - Specific to Calendar Page */}
          <div style={{ textAlign:'center', backgroundColor:'#04330c', color:'white', padding:'8px', fontWeight:'bold', fontSize:'0.9rem', marginTop:'15px' }}>
            {formatEngDate(pd.EnglishDate)} க்ரஹநிலை
          </div>
          <div style={{ backgroundColor:T.cream, padding:'10px', border:'2px solid #04330c' }}>
            {pd.GrahasPositionsShortInTamilStringified ? (
              <GrahaNilaiGrid pos={typeof pd.GrahasPositionsShortInTamilStringified === 'string' ? JSON.parse(pd.GrahasPositionsShortInTamilStringified) : pd.GrahasPositionsShortInTamilStringified} />
            ) : (
              <div style={{textAlign:'center', padding:'20px'}}>க்ரஹநிலை விபரம் கிடைக்கவில்லை</div>
            )}
          </div>

          {/* Star Finder Form */}
          <div style={{ marginTop:'25px', backgroundColor:'#fff', padding:'15px', borderRadius:'10px', border:'1px solid '+T.border }}>
            <h2 style={{ fontSize:'1.1rem', color:T.greenDk, marginTop:0 }}>நக்ஷத்திரத்திற்கு தேதி அறிய</h2>
            <div style={{ fontSize:'0.8rem', color:T.maroon, marginBottom:'15px' }}>
              ஆண்டு, மாதம், நக்ஷத்திரத்தை தேர்வு செய்து ஸப்மிட் செய்தால் அந்த நாளின் விபரம் கீழே காண்பிக்கப்படும்.
            </div>

            <form onSubmit={handleStarSearch}>
              <div style={{ display:'flex', marginBottom:'10px', alignItems:'center' }}>
                <div style={{ width:'40%', fontSize:'0.9rem', fontWeight:'bold' }}>வருடம் :</div>
                <select value={starYear} onChange={(e)=>setStarYear(e.target.value)} style={{ width:'60%', padding:'8px', borderRadius:'6px' }}>
                  <option value="39">விஶ்வாவசு -2025-26</option>
                  <option value="38">குரோதி-2024-25</option>
                  <option value="37">சோபக்ருது-2023-24</option>
                  <option value="36">சுபக்ருது-2022-23</option>
                  <option value="35">பிலவ-2021-22</option>
                </select>
              </div>

              <div style={{ display:'flex', marginBottom:'10px', alignItems:'center' }}>
                <div style={{ width:'40%', fontSize:'0.9rem', fontWeight:'bold' }}>மாதம் :</div>
                <select value={starMonth} onChange={(e)=>setStarMonth(e.target.value)} style={{ width:'60%', padding:'8px', borderRadius:'6px' }}>
                  <option value="1">சித்திரை</option>
                  <option value="2">வைகாசி</option>
                  <option value="3">ஆனி</option>
                  <option value="4">ஆடி</option>
                  <option value="5">ஆவணி</option>
                  <option value="6">புரட்டாசி</option>
                  <option value="7">ஐப்பசி</option>
                  <option value="8">கார்த்திகை</option>
                  <option value="9">மார்கழி</option>
                  <option value="10">தை</option>
                  <option value="11">மாசி</option>
                  <option value="12">பங்குனி</option>
                </select>
              </div>

              <div style={{ display:'flex', marginBottom:'15px', alignItems:'center' }}>
                <div style={{ width:'40%', fontSize:'0.9rem', fontWeight:'bold' }}>நக்ஷத்ரம் :</div>
                <select value={starStar} onChange={(e)=>setStarStar(e.target.value)} style={{ width:'60%', padding:'8px', borderRadius:'6px' }}>
                  {['அஸ்விநி','பரணி','கார்த்திகை','ரோகிணி','மிருகசீர்ஷம்','திருவாதிரை','புனர்பூசம்','பூசம்','ஆயில்யம்','மகம்','பூரம்','உத்தரம்','ஹஸ்தம்','சித்திரை','ஸ்வாதி','விசாகம்','அநுஷம்','கேட்டை','மூலம்','பூராடம்','உத்ராடம்','திருவோணம்','அவிட்டம்','சதயம்','பூரட்டாதி','உத்ரட்டாதி','ரேவதி'].map((s,i) => (
                    <option key={i+1} value={i+1}>{s}</option>
                  ))}
                </select>
              </div>

              <button type="submit" disabled={starLoading} style={{ width:'100%', padding:'12px', background:T.greenDk, color:'#fff', border:'none', borderRadius:'6px', fontWeight:'bold', fontSize:'1rem' }}>
                {starLoading ? 'தேடுகிறது...' : 'Submit'}
              </button>
            </form>

            {starResult && (
              <div style={{ marginTop:'20px', background:T.bg, padding:'10px', borderRadius:'8px', border:'1px solid '+T.border }}>
                <h3 style={{ fontSize:'1rem', marginTop:0, color:T.greenDk }}>தேர்வுசெய்த நக்ஷத்திர நாள்</h3>
                <Row label="தமிழ் தேதி" value={`${starResult.YearNameInTamil} - ${starResult.TamilMonth} - ${starResult.TamilDate}`} />
                <Row label="ஆங்.தேதி" value={`${formatEngDate(starResult.EnglishDate)} - ${starResult.DayNameInTamil}`} />
                <Row label="பக்ஷ-திதி" value={`${starResult.Paksham}-${starResult.ThithiNameInTamil} (${formatNumber(starResult.ThithiDuration)}) IST`} />
                <Row label="நக்ஷத்ரம்" value={`${starResult.NakshatraNameInTamil} (${formatNumber(starResult.NakshatraDuration)}) IST`} />
              </div>
            )}
            
            {starResult2 && (
              <div style={{ marginTop:'10px', background:T.bg, padding:'10px', borderRadius:'8px', border:'1px solid '+T.border }}>
                <Row label="தமிழ் தேதி" value={`${starResult2.YearNameInTamil} - ${starResult2.TamilMonth} - ${starResult2.TamilDate}`} />
                <Row label="ஆங்.தேதி" value={`${formatEngDate(starResult2.EnglishDate)} - ${starResult2.DayNameInTamil}`} />
                <Row label="பக்ஷ-திதி" value={`${starResult2.Paksham}-${starResult2.ThithiNameInTamil} (${formatNumber(starResult2.ThithiDuration)}) IST`} />
                <Row label="நக்ஷத்ரம்" value={`${starResult2.NakshatraNameInTamil} (${formatNumber(starResult2.NakshatraDuration)}) IST`} />
              </div>
            )}
            
            {starResult && (
               <div style={{ fontSize:'0.75rem', background:'blue', color:'#F2E100', padding:'8px', marginTop:'10px', borderRadius:'4px' }}>
                  குறிப்பு:-நாளின் தொடக்கத்தில் தேர்வு செய்த நக்ஷத்திரம் இல்லாவிடில் முன் நக்ஷத்ரம் காண்பிக்கப்படும். அதன் முடிவு நேரத்திற்குப் பின் இந்த நக்ஷத்திரம் ஆரம்பித்து அன்றைக்குள் முடிவதாகப் பொருள்.
               </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

// Reusable Row Component
const Row = ({ label, value, smallFont, smallLabel }) => (
  <div style={{ display:'flex', borderBottom:'1px dotted #ccc', fontSize:'0.9rem' }}>
    <div style={{ width:'32%', padding:'6px 4px', color:'#1b5e20', fontWeight:'bold', fontSize: smallLabel ? '0.7rem' : '0.85rem' }}>
      {label}
    </div>
    <div style={{ width:'68%', padding:'6px 4px', fontSize: smallFont ? '0.80rem' : '0.85rem', color:'#333' }}>
      {value}
    </div>
  </div>
);

// Graha Nilai 4x4 Grid Component
const GrahaNilaiGrid = ({ pos }) => {
  const cellStyle = { border: '1px solid #1b5e20', padding: '5px', textAlign: 'center', height: '60px', width: '25%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.75rem', fontWeight: 'bold' };
  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <div style={{ display: 'flex', width: '100%' }}>
        <div style={cellStyle}>{pos['12']}</div>
        <div style={cellStyle}>{pos['1']}</div>
        <div style={cellStyle}>{pos['2']}</div>
        <div style={cellStyle}>{pos['3']}</div>
      </div>
      <div style={{ display: 'flex', width: '100%' }}>
        <div style={cellStyle}>{pos['11']}</div>
        <div style={{ ...cellStyle, width: '50%', borderBottom: 'none' }}>
           {/* Center Logo Area */}
        </div>
        <div style={cellStyle}>{pos['4']}</div>
      </div>
      <div style={{ display: 'flex', width: '100%' }}>
        <div style={cellStyle}>{pos['10']}</div>
        <div style={{ ...cellStyle, width: '50%', borderTop: 'none', flexDirection:'column' }}>
            <span style={{fontSize:'0.7rem', color:'#6d1b1b'}}>ஸ்ரீ பரந்தாமன்</span>
            <span style={{fontSize:'0.7rem', color:'#6d1b1b'}}>பஞ்சாங்கம்</span>
        </div>
        <div style={cellStyle}>{pos['5']}</div>
      </div>
      <div style={{ display: 'flex', width: '100%' }}>
        <div style={cellStyle}>{pos['9']}</div>
        <div style={cellStyle}>{pos['8']}</div>
        <div style={cellStyle}>{pos['7']}</div>
        <div style={cellStyle}>{pos['6']}</div>
      </div>
    </div>
  );
};

export default CalendarPage;